import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ProjectsSvg = function ProjectsSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22 10.648 17.332 2.25l-4.668 8.4zm-2.393-1.427h-4.55l2.275-4.094zM9.898 2.249H2v8.12h7.898zm-6.51 6.693V3.677H8.51v5.265zM3.293 14.556a4.32 4.32 0 0 1 3.1-1.32c1.162 0 2.276.475 3.098 1.32a4.57 4.57 0 0 1 1.284 3.187 4.57 4.57 0 0 1-1.284 3.186 4.32 4.32 0 0 1-3.099 1.32 4.32 4.32 0 0 1-3.1-1.32 4.57 4.57 0 0 1-1.283-3.186c0-1.196.462-2.342 1.284-3.187m3.1.108c-.795 0-1.557.324-2.118.902a3.12 3.12 0 0 0-.877 2.177c0 .816.315 1.6.877 2.177a2.95 2.95 0 0 0 2.117.901c.794 0 1.556-.324 2.117-.902.562-.577.877-1.36.877-2.176s-.315-1.6-.877-2.177a2.95 2.95 0 0 0-2.117-.902",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M12.664 15.556 22 15.552v-1.428l-9.336.005zM12.664 20.821 22 20.817v1.428l-9.336.004zM22 17.47l-9.336.005v1.428L22 18.898z"
    })]
  });
};
export var Projects = function Projects(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: ProjectsSvg
  }));
};